module.exports = __webpack_public_path__ + "static/img/welcome.ab8a182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome.jpg
// module id = 2QhH
// module chunks = 1